import React from 'react';
import { AppLayoutProviders, SidebarLayout } from '../layout/SidebarLayout';

const Patients = () => (
  <AppLayoutProviders>
    <SidebarLayout>
      <div className='bg-white border border-brand-navy/15 rounded-lg p-6 shadow-sm'>
        <p className='text-sm text-gray-600'>
          <span className='font-medium text-brand-navy'>Patients</span> — Select a patient from the sidebar or add a new one.
        </p>
      </div>
    </SidebarLayout>
  </AppLayoutProviders>
);

export default Patients;
